const selector = '.copy-text';

function copyText(text, confirmationText) {
  if (!navigator.clipboard) {
    copyTextFallback(text, confirmationText);
    return;
  }
  navigator.clipboard.writeText(text)
    .then(function() {
      window.toaster(confirmationText);
    })
    .catch(function (err) {
      console.error('Could not copy text', err);
    });
}

function copyTextFallback(text, confirmationText) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    window.toaster(confirmationText);
  } catch (err) {
    console.error('Could not copy text with execCommand', err);
  }

  document.body.removeChild(textArea);
}

export default function() {
  $(window.document).on('click', selector, function(e) {
    e.preventDefault();
    const $btnEl = $(this);
    if (!$btnEl.data('text')) {
      return;
    }
    copyText($btnEl.data('text'), $btnEl.data('confirmation') || 'Text copied');
  });
}



// WEBPACK FOOTER //
// ./scripts/components/copy-text.js